import { Controller } from '../utils/controller';

export default class extends Controller {
  static values = {
    cursorUrl: String,
    logoTop: String,
    logoTopMedium: String
  };

  // VALUES
  declare cursorUrlValue: string | undefined;
  declare logoTopValue: string | undefined;
  declare logoTopMediumValue: string | undefined;
  connect() {
    const root = document?.querySelector(':root');
    if (this.cursorUrlValue && root) {
      root.style?.setProperty('--cursor-url', 'url(' + this.cursorUrlValue + '), auto');
    }
    if (this.logoTopValue && root) {
      root.style?.setProperty('--logo-top', this.logoTopValue);
    }
    if (this.logoTopMediumValue && root) {
      root.style?.setProperty('--logo-top-medium', this.logoTopMediumValue);
    }
  }
}
